<template>
  <div v-if="ereporterChip">
    <v-badge dot inline color="red">{{ text }}</v-badge>
  </div>
  <div v-else>
    {{ text }}
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mapCacheActions } from 'vuex-cache';

export default {
  name: 'EreporterBadge',

  props: {
    text: {
      type: String,
      required: true
    }
  },

  computed: {
    ...mapState('ereporter', ['ereporterChip'])
  },

  mounted() {
    this.getActualQTYRequestVacations();
  },

  created() {
    this.getQTYRequestVacations();
  },

  methods: {
    ...mapCacheActions('request_vacations', [
      'getQTYRequestVacations',
      'getActualQTYRequestVacations'
    ])
  }
};
</script>
